import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const LoanRemarksUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  remarks, onRemarksChange, remarksError, setRemarksError,
  action, onActionChange, actionError, setActionError, actionList,
  actionStatus, onActionStatusChange, actionStatusError, setActionStatusError, actionStatusList,
  dateISO, onDateISOChange, dateISOError, setDateISOError,
  //
  legal
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF type='text' name='remarks' label='Internal remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
      help='Remove remarks to delete this record; 2000 characters max'
    />
    {legal &&
      <InputSelectSF
        type='select' name='action' label='Action'
        value={action} onChange={onActionChange} optionList={actionList.map(item => ({ value: item.key, value: item.value }))}
        error={actionError} setError={setActionError}
      />
    }
    {legal &&
      <InputDateUI type='date' name='date' label='Action Date'
        context={context}
        selectedDateISO={dateISO} onChange={onDateISOChange}
        error={dateISOError} setError={setDateISOError}
      />
    }
    {legal &&
      <InputSelectSF
        type='select' name='actionStatus' label='Action Status'
        value={actionStatus} onChange={onActionStatusChange} optionList={actionStatusList.map(item => ({ key: item.key, value: item.value }))}
        error={actionStatusError} setError={setActionStatusError}
      />
    }
  </ModalFormUI>

export default LoanRemarksUpdateModalUI
